import { render } from "./rechargedetail.vue?vue&type=template&id=10a0f907&scoped=true"
import script from "./rechargedetail.vue?vue&type=script&lang=js"
export * from "./rechargedetail.vue?vue&type=script&lang=js"

import "./rechargedetail.vue?vue&type=style&index=0&id=10a0f907&scoped=true&lang=css"

import exportComponent from "/Users/shan/www/xnz_merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a0f907"]])

export default __exports__